export interface ResourceType {
  ko: {
    [key: string]: string;
  };
  en: {
    [key: string]: string;
  };
}

// export const t = (key: string, lang: 'ko' | 'en', resource: ResourceType): string => {
//   return resource[lang as keyof ResourceType][key] || '';
// };

export const t = (
  key: string,
  lang: 'ko' | 'en',
  resource: ResourceType,
  params?:
    | {
        [key: string]: string | number;
      }
    | undefined
): string => {
  if (params === undefined) {
    return resource[lang as keyof ResourceType][key] || '';
  }

  let str = resource[lang as keyof ResourceType][key];
  for (const [key, value] of Object.entries(params)) {
    str = str.replace(`{{${key}}}`, value.toString());
  }
  return str;
};
